import { code } from '../components/basic/code';

const port = '5000';

const host = code.isDevelopmentEnv()
    ? // ipn back url
      'http://localhost:' + port
    : 'https://api.fateeh.ir';

export const apiConfig = {
    host: host,
    localeUrl: host,
    baseUrl: host,
    accountUrl: host + '/authentication',
    networkUrl: host + '/network',
    attachmentUrl: host + '/attachment',
};
